var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Textfield',{attrs:{"hideDetails":"","clearable":"","label":"Suche"},on:{"input":function($event){return _vm.emitSearch($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }